import React from "react";
import styled from "styled-components";

const DropdownContainer = styled.div`
     position: absolute;
    top: 210px;
    background-color: white;
   box-shadow: 0px 0px 4px 0px #00000029;
    width: 140px;
    z-index: 300;
    right: 14px;
    border-radius: 6px;
    height: auto;
    width: 147px;
}
`;

const DropdownOption = styled.div`
  height: 32px;
  cursor: pointer;
  font-size: 12px;
  color: #1e1e1e;
  font-weight: 600;
  padding: 8px 0px 8px 14px;
  &:hover {
    background-color: #f2f6f9;
  }

  &:first-child:hover {
    border-radius: 6px 6px 0px 0px;
  }

  &:last-child:hover {
    border-radius: 0px 0px 6px 6px;
  }
`;

const ListText = styled.span`
  
`;
const DropdownCreate = ({ options, onSelectOption }) => {
  return (
    <DropdownContainer>
      {options.map((option, index) => (
        <DropdownOption key={index} onClick={() => onSelectOption(option)}>
          <ListText>{option}</ListText>
        </DropdownOption>
      ))}
    </DropdownContainer>
  );
};

export default DropdownCreate;
